import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IToastFeature } from './toast.feature.state';
import { ToastState } from './toast.state';

export const getToastState: MemoizedSelector<IToastFeature, ToastState> = createFeatureSelector<ToastState>(
  nameof<IToastFeature>('toastFeature')
);

export const getIsLoading = createSelector(getToastState, (state: ToastState) => state.isLoading);

export const getFailures = createSelector(getToastState, (state: ToastState) => state.failures);
